<template>
  <q-input
    :for="forLabel"
    :label="label"
    :mask="mask"
    :maxlength="maxLength"
    :placeholder="placeholder"
    :readonly="disabled"
    :rules="rules"
    bg-color="white"
    class="myFieldText"
    dense
    outlined
    v-model="text"
  >
    <template
      #prepend
      v-if="preparendText"
    >
      <div
        style="font-size: 0.5em; margin-top: 5px;"
        class="col-auto"
      >
        {{ preparendText }}:
      </div>
    </template>
    <template
      #before
      v-if="icon != 'none'"
    >
      <q-icon
        :name="icon"
        :color="iconColor"
      />
    </template>
  </q-input>
</template>

<script>

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    forLabel: {},

    label: {},

    icon: {
      type: String,
      default: 'none'
    },

    iconColor: {
      type: String,
      default: 'primary'
    },

    mask: { type: String },

    maxLength: { type: String },

    placeholder: {},

    preparendText: {},

    rules: {},

    value: {},
    height: {
      type: String,
      default: '32px'
    }
  },

  data () {
    const text = forceStr(this.value)
    return { text }
  },

  watch: {
    text (text) {
      if (isEqual(text, this.value)) return
      this.$emit('input', forceStr(text))
    },

    value (value) {
      if (isEqual(this.text, value)) return
      this.text = forceStr(value)
    }
  }
}

const forceStr = (val) => String(val ?? '').trim()
const isEqual = (source, target) => forceStr(source) === forceStr(target)

</script>

<style lang="sass">
  .myFieldText
    .q-field__control
      height: v-bind(height)
      min-height: v-bind(height)
      padding: 0 4px 0 8px

      .q-field__control-container
        font-style: normal
        font-weight: normal
        font-size: 13px
        line-height: 18px
        color: rgba(38,50,56, 0.9)

      &:hover
        &:before
          border: 1px solid #486e8e
          transition: none

      &:after
        border-width: 1px !important

    .q-field__control-container
      .q-field__native
        min-height: 32px
        padding-bottom: 5px

      .q-field__prefix
        line-height: inherit !important
        margin-bottom: 1px
        padding: 1px 1px 0 0

    .q-field__marginal
      height: 32px
      padding-bottom: 5px

    .fontChips
      div.ellipsis
        font-style: normal
        font-weight: normal
        font-size: 12px
        margin-right: 5px

    .font-item
      font-style: normal
      font-weight: normal
      font-size: 13px
      line-height: 18px
      color: #263238

  .borderUnSelected div.q-checkbox__bg
    border: 1px solid #9E9E9E !important
</style>
